import * as v from 'valibot';
import { EmailAddress } from './credentials.js';
import { identifier, pii, secret, } from './domain-string.js';
import { coercedDate, Time, Weekday } from './shared.js';
export const StudentName = pii('student-name');
export const StudentNotes = pii('student-notes');
export const StudentId = identifier('student-id');
export const StudentSurveyToken = secret('student-survey-token');
export const StudentPreference = v.union([
    v.literal('impossible'),
    v.literal('difficult'),
    v.literal('neutral'),
    v.literal('works'),
    v.literal('perfect'),
]);
export const StudentPreferenceSlot = v.object({
    weekday: Weekday,
    startTime: Time,
    endTime: Time,
    selection: StudentPreference,
});
export const StudentSettings = v.object({
    preferences: v.array(StudentPreferenceSlot),
    lessonMinutes: v.number(),
    lastUpdated: v.nullable(coercedDate()),
});
export const StudentToken = v.object({
    id: StudentSurveyToken,
    dueByDate: coercedDate(),
    createdAt: coercedDate(),
    lastActiveAt: v.nullable(coercedDate()),
});
export const Student = v.object({
    id: StudentId,
    name: StudentName,
    email: EmailAddress,
    notes: StudentNotes,
    archived: v.optional(v.boolean(), false),
    settings: StudentSettings,
    token: v.nullable(StudentToken),
});
//# sourceMappingURL=student.js.map